import { WebhookDeliveryRowType } from 'src/types/webhookDeliveriesGrid';

export const isAutoRetryInProgress = (row: WebhookDeliveryRowType): boolean => {
    if (row.SUCCESS || row.STATUS_CODE === 200 || row.STATUS_CODE === 404) {
        return false;
    }
    if (row.AUTO_RETRY_IN_PROGRESS) {
        return true;
    }
    if (!row.NEXT_RETRY_AT) {
        return false;
    }

    return new Date(row.NEXT_RETRY_AT).getTime() > Date.now();
};

export const getStatusColor = (statusCode: number | null | undefined): string => {
    if (statusCode === 200) {
        return '#2e7d32';
    }
    return '#d32f2f';
};

export const stringifyPayload = (payload: WebhookDeliveryRowType['PAYLOAD']): string => {
    if (payload === null || payload === undefined) {
        return '';
    }
    if (typeof payload === 'string') {
        return payload;
    }
    try {
        return JSON.stringify(payload);
    } catch {
        return String(payload);
    }
};

export const formatJsonForDisplay = (value: string): string => {
    if (!value) {
        return '';
    }
    try {
        return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
        return value;
    }
};

export const isJsonString = (value: string): boolean => {
    if (!value.trim()) {
        return false;
    }
    try {
        JSON.parse(value);
        return true;
    } catch {
        return false;
    }
};

export const shouldShowWebhookPayload = (
    method: string | null | undefined,
    payload: WebhookDeliveryRowType['PAYLOAD'],
): boolean => {
    if ((method || 'POST').toUpperCase() === 'GET') {
        return false;
    }
    return Boolean(stringifyPayload(payload).trim());
};

export const canRetryDelivery = (row: WebhookDeliveryRowType): boolean =>
    row.STATUS_CODE !== 200 &&
    !row.MANUAL_RETRY_REQUESTED &&
    !isAutoRetryInProgress(row);

export type RetryBlockedReason =
    | 'success'
    | 'manualRetryRequested'
    | 'autoRetryInProgress'
    | null;

export const getRetryBlockedReason = (row: WebhookDeliveryRowType): RetryBlockedReason => {
    if (row.STATUS_CODE === 200) {
        return 'success';
    }
    if (row.MANUAL_RETRY_REQUESTED) {
        return 'manualRetryRequested';
    }
    if (isAutoRetryInProgress(row)) {
        return 'autoRetryInProgress';
    }
    return null;
};
